import {
    setStoredCredentials
} from "../util";

import { AuthSetTokenAction } from "../actions/AuthSetToken";
import { AuthState } from "../state";
import { auth0SessionToCredentials } from "../util";


export function authSetToken(state: AuthState, action: AuthSetTokenAction): AuthState {
    const credentials = auth0SessionToCredentials({
        accessToken: action.payload.accessToken,
        expiresIn: action.payload.expiresInSeconds,
        refreshToken: action.payload.refreshToken
    });
    setStoredCredentials(credentials);
    return { ...state, ...action.payload, credentials, error: undefined };
}